import { render, staticRenderFns } from "./MarketplaceFilter.vue?vue&type=template&id=5b2a89d0&"
import script from "./MarketplaceFilter.vue?vue&type=script&lang=js&"
export * from "./MarketplaceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports